/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForZohoServiceDesk extends models.GovernanceConfigurationBaseForItsm {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForZohoServiceDesk.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForZohoServiceDesk>): GovernanceConfigurationBaseForZohoServiceDesk {
        let obj = Object.assign(new GovernanceConfigurationBaseForZohoServiceDesk(), model);
        GovernanceConfigurationBaseForZohoServiceDesk.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForZohoServiceDesk>): GovernanceConfigurationBaseForZohoServiceDesk {
        if (!model) return null;
        return GovernanceConfigurationBaseForZohoServiceDesk.newInstance(<GovernanceConfigurationBaseForZohoServiceDesk> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForZohoServiceDesk) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForZohoServiceDesk.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForZohoServiceDesk): boolean {
        if (models.GovernanceConfigurationBaseForItsm.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForZohoServiceDesk.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
